import React, { PureComponent, Fragment } from 'react'
import Proptypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileWord, faFileExcel, faFilePdf, faPrint } from '@fortawesome/free-solid-svg-icons'
import './css/ExportButtons.scss'

class ExportButtons extends PureComponent {
  returnButtons = () => {
    const buttonsArray = [faFileWord, faFileExcel, faFilePdf, faPrint]
    return buttonsArray.map((item, i) => {
      return <div className="export-buttons-with-bg" key={i}>
        <div className="export-img-wrap">
          <FontAwesomeIcon icon={item} alt="export icon" />
        </div>
        <div>{['word', 'excel', 'pdf', 'print'][i]}</div>
      </div>
    })
  }

  render () {
    const { showOnlyButtons } = this.props
    return <div className="export-buttons-wrapper">
      {showOnlyButtons
        ? null
        : <Fragment>
          <div className="export-buttons-green-btn">Import List</div>
          <div className="export-buttons-green-btn">|</div>
          <div className="export-buttons-green-btn">Export</div>
        </Fragment>}
      <div className="d-flex justify-content-between align-item-center">
        {this.returnButtons()}
      </div>
    </div>
  }

  static propTypes = {
    showOnlyButtons: Proptypes.bool
  }
}

export default ExportButtons



// WEBPACK FOOTER //
// ./src/components/ExportButtons/ExportButtons.js